import {
  Alert,
  Autocomplete,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  Link,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Add as AddIcon } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { NavLink, useNavigate } from "react-router-dom";
import Loading from "../components/Loading";
import { Helmet } from "react-helmet-async";
import axios from "../../CustomAxios";

function UpdatePhysicalStock() {
  const [loader, setLoader] = useState(true);
  const [companies, setCompanies] = useState(false);
  const [apCompany, setApCompany] = useState(false);
  const navigate = useNavigate();
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const [plates, setPlates] = useState([
    {
      plateId: "",
      digitalQuantity: "",
      plateNewQuantity: "",
    },
  ]);
  const [plateData, setPlateData] = useState([{ label: "" }]);
  const addPlate = () => {
    setPlates((prev) => [
      ...prev,
      {
        plateId: "",
        digitalQuantity: "",
      },
    ]);
  };
  const handleSubmit = async () => {
    try {
      setLoader(true);
      const isAnyPlateEmpty = plates.some((plate) => plate.plateId === "");
      if (isAnyPlateEmpty) {
        setErr("Please fill all plate details sections");
        snackRef.current.click();
        return;
      }
      // console.log("plate data is", plates);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      const { data } = await axios.put(
        `/api/v1/${authData?.type}/physical_stock/update/${apCompany}`,
        {
          plate_details: plates,
        },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
        navigate("/dashboard/inventory/physical-stock", {
          state: {
            success: true,
            message: "Physical Stock Updated Successfully",
          },
        });
      }
    } catch (e) {
      setLoader(false);
      setErr(e.response.data.error);
      snackRef.current.click();
    }
  };
  const handleQuantityChange = (e) => {
    const updatedPlates = [...plates];
    updatedPlates[Number(e.target.name)].plateNewQuantity = Number(
      e.target.value
    );
    setPlates(updatedPlates);
  };
  const removePlate = (plateToRemove) => {
    const updatedPlates = plates.filter((plate) => plate !== plateToRemove);
    setPlates(updatedPlates);
  };

  const handleApCompanyClick = async (e, newValue) => {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };

    const data = await axios.get(
      `/api/v1/${authData?.type}/plate_inventory/get_inventory/?ap_company=${newValue.id}`,
      config
    );
    // console.log("Data for plates is", data.data.data.data);
    let tempData = data.data.data.data;
    let rows = [];
    // eslint-disable-next-line
    const temp = tempData.map((element, index) => {
      rows.push({
        label: `${element.details.plate.height}X${element.details.plate.width}X${element.details.plate.thickness} || ${element.details.plate.company} || ${element.details.plate.technology.name}`,
        id: element.details.plate._id,
        quantity: element.details.quantity,
      });
      return element;
    });
    setPlateData(rows);
    setApCompany(newValue.id);
  };
  async function getData() {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${userData?.type}/plate_inventory/inward_outward/ap_companies`,
      config
    );
    let companyData = data?.data;
    let rows = [];
    // eslint-disable-next-line
    const tempRow = companyData?.map((element, index) => {
      rows.push({ label: element.name, id: element._id });
      return element;
    });
    // console.log("Data is", data);
    setCompanies(rows);
    setLoader(false);
  }

  useEffect(() => {
    getData();
  }, []);
  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              Add Physical stock
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/physical-stock">
                PhysicalStock
              </Link>
              <Typography>Add Stock</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Button
          ref={snackRef}
          style={{ display: "none" }}
          onClick={handleClick({ vertical: "top", horizontal: "center" })}
        >
          Click
        </Button>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={handleClose}
          key={vertical + horizontal}
        >
          {err ? (
            <Alert mt={2} mb={4} severity="error">
              {err}
            </Alert>
          ) : success ? (
            <Alert mt={2} mb={4} severity="success">
              Physical Stock updated successfully
            </Alert>
          ) : null}
        </Snackbar>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card mb={6}>
              <CardContent>
                <Paper elevation={3} style={{ padding: "2%" }}>
                  <Grid container spacing={5}>
                    <Grid item xs={12} lg={12} md={12}>
                      <Typography variant="h6" gutterBottom color="primary">
                        AP Company
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <Autocomplete
                        disablePortal
                        options={companies}
                        renderInput={(params) => (
                          <TextField {...params} label="Select AP Company" />
                        )}
                        onChange={handleApCompanyClick}
                      />
                    </Grid>

                    {!loader &&
                      plates.map((plate, index) => {
                        // console.log("rendering");
                        return (
                          <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                          >
                            <Grid
                              item
                              xs={12}
                              md={6}
                              lg={6}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              <Autocomplete
                                disablePortal
                                size="small"
                                options={plateData}
                                key={index}
                                sx={{ width: "95%" }}
                                onChange={(e, newValue) => {
                                  const updatedPlateDetails = [...plates];
                                  updatedPlateDetails[index].plateId =
                                    newValue.id;
                                  updatedPlateDetails[index].digitalQuantity =
                                    newValue.quantity;
                                  updatedPlateDetails[index].plateNewQuantity =
                                    newValue.quantity;

                                  setPlates(updatedPlateDetails);
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} label="Plate" />
                                )}
                              />

                              {
                                // eslint-disable-next-line
                                index != 0 && (
                                  <CloseIcon
                                    onClick={() => {
                                      removePlate(plate);
                                    }}
                                    sx={{
                                      height: "100%",
                                      border: "1px solid lightGrey",
                                      borderLeft: 0,
                                      borderRadius: "0 5px 5px 0",
                                      padding: "0 2px",
                                      cursor: "pointer",
                                    }}
                                  />
                                )
                              }
                            </Grid>
                            {/* </div> */}
                            {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}> */}
                            <Grid
                              item
                              xs={12}
                              md={2}
                              lg={3}
                              sx={{ marginLeft: "30px" }}
                            >
                              <TextField
                                size="small"
                                sx={{ width: "100%" }}
                                disabled
                                value={`Digital Quantity : ${plate.digitalQuantity}`}
                              />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              md={2}
                              lg={3}
                              sx={{ marginLeft: "30px" }}
                            >
                              <TextField
                                size="small"
                                sx={{ width: "100%" }}
                                label="Physical Quantity"
                                name={String(index)}
                                onChange={handleQuantityChange}
                                value={plate.plateNewQuantity}
                              />
                            </Grid>
                            {/* </div> */}
                          </Grid>
                        );
                      })}

                    <Button
                      onClick={addPlate}
                      mr={2}
                      variant="contained"
                      color="primary"
                      sx={{
                        marginTop: "20px",
                        marginLeft: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      Add Plate
                      <AddIcon />
                    </Button>
                  </Grid>
                  <Divider />
                  <Grid item xs={12} md={12} lg={12}>
                    <Button
                      type="submit"
                      style={{ textAlign: "center", marginTop: "20px" }}
                      mr={2}
                      variant="contained"
                      color="primary"
                      // disabled={handleSubmit}
                      onClick={handleSubmit}
                    >
                      Update Physical Stock
                    </Button>
                  </Grid>
                </Paper>
              </CardContent>
            </Card>
            <Grid Grid container spacing={5}></Grid>
            {/* <Button
              // onClick={addPlate}
              onClick={handleSubmit}
              mr={2}
              variant="contained"
              color="primary"
              sx={{ marginTop: "20px" }}
              // disabled={missingPermissions.length > 0}
            >
              Submit
            </Button> */}
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

export default UpdatePhysicalStock;
